export const palette = {
  indirect: "#1b6002",
  mediating: "#437387",
  outcome: "#2e3348",
};

// bootstrap 4.6 breakpoints
export const breakpoints = {
  xl: 1200,
  lg: 992,
  md: 768,
  sm: 576,
}
